import { useEffect, useState } from "react";
import {
  ButtonTab,
  Container,
  ContainerPages,
  Menu,
  OptionsContainer,
} from "./styles";
import {
  GrayTitle,
  LoadingGif,
  LoadingOverlay,
  StyledHR,
  TitleAndButton,
} from "../../shared/styles/global.styles";
import loadSCGif from "../../assets/load_SC.gif";
import { useAuth } from "../../AuthContext/AuthContext";
import { ModulosEnum } from "../../shared/enum/modulos.enum";
import { PermissoesEnum } from "../../shared/enum/permicao.enum";
import Lotacao from "./Lotacao/lotacao";
import LocalPagamento from "./LocalPagamento/localPagamento";
import FormaPagamento from "./FormaPagamento/formaPagamento";
import InstrucaoBancaria from "./InstrucaoBancaria/instrucaoBancaria";

const CadastrosGerais: React.FC = () => {
  const { checkPermission } = useAuth();
  const editLotacaoOnly = checkPermission(
    ModulosEnum.LOTACOES,
    PermissoesEnum.ESCRITA
  );

  const readLotacaoOnly = checkPermission(
    ModulosEnum.LOTACOES,
    PermissoesEnum.LEITURA
  );

  const editLocalPagamentoOnly = checkPermission(
    ModulosEnum.LOCAL_PAGAMENTO,
    PermissoesEnum.ESCRITA
  );

  const readLocalPagamentoOnly = checkPermission(
    ModulosEnum.LOCAL_PAGAMENTO,
    PermissoesEnum.LEITURA
  );

  const editFormaPagamentoOnly = checkPermission(
    ModulosEnum.FORMA_PAGAMENTO,
    PermissoesEnum.ESCRITA
  );

  const readFormaPagamentoOnly = checkPermission(
    ModulosEnum.FORMA_PAGAMENTO,
    PermissoesEnum.LEITURA
  );

  const editInstrucoesBancariasOnly = checkPermission(
    ModulosEnum.INSTRUCOES_BANCARIAS,
    PermissoesEnum.ESCRITA
  );

  const readInstrucoesBancariasOnly = checkPermission(
    ModulosEnum.INSTRUCOES_BANCARIAS,
    PermissoesEnum.LEITURA
  );

  const [selectTab, setSelectTab] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const checkOpenTab = () => {
    if (editLotacaoOnly || readLotacaoOnly) {
      setSelectTab(0);
      setIsLoading(false);
      return;
    }
    if (editLocalPagamentoOnly || readLocalPagamentoOnly) {
      setSelectTab(1);
      setIsLoading(false);
      return;
    }
    if (editFormaPagamentoOnly || readFormaPagamentoOnly) {
      setSelectTab(2);
      setIsLoading(false);
      return;
    }
    if (editInstrucoesBancariasOnly || readInstrucoesBancariasOnly) {
      setSelectTab(3);
      setIsLoading(false);
      return;
    }
    setIsLoading(false);
  };

  const handleSelectTab = (tab: number) => {
    setIsLoading(true);
    setSelectTab(tab);
    setIsLoading(false);
  };

  useEffect(() => {
    checkOpenTab();
  }, []);

  return (
    <>
      {!isLoading ? (
        <Container>
          <TitleAndButton>
            <GrayTitle>Cadastros Gerais</GrayTitle>
          </TitleAndButton>
          <StyledHR />
          <Menu
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <OptionsContainer
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              {(editLotacaoOnly || readLotacaoOnly) && (
                <ButtonTab
                  onClick={() => {
                    handleSelectTab(0);
                  }}
                  active={selectTab === 0}
                  disabled={false}
                >
                  Lotação
                </ButtonTab>
              )}

              {(editLocalPagamentoOnly || readLocalPagamentoOnly) && (
                <ButtonTab
                  onClick={() => {
                    handleSelectTab(1);
                  }}
                  active={selectTab === 1}
                  disabled={false}
                >
                  Local de pagamento
                </ButtonTab>
              )}

              {(editFormaPagamentoOnly || readFormaPagamentoOnly) && (
                <ButtonTab
                  onClick={() => {
                    handleSelectTab(2);
                  }}
                  active={selectTab === 2}
                  disabled={false}
                >
                  Forma de pagamento
                </ButtonTab>
              )}

              {(editInstrucoesBancariasOnly || readInstrucoesBancariasOnly) && (
                <ButtonTab
                  onClick={() => {
                    handleSelectTab(3);
                  }}
                  active={selectTab === 3}
                  disabled={false}
                >
                  Instruções bancárias
                </ButtonTab>
              )}
            </OptionsContainer>
          </Menu>

          <ContainerPages>
            {(() => {
              switch (selectTab) {
                case 0:
                  return <Lotacao />;
                case 1:
                  return <LocalPagamento />;
                case 2:
                  return <FormaPagamento />;
                case 3:
                  return <InstrucaoBancaria />;
                default:
                  return null;
              }
            })()}
          </ContainerPages>
        </Container>
      ) : (
        <LoadingOverlay>
          <LoadingGif src={loadSCGif} alt="Carregando..." />
        </LoadingOverlay>
      )}
    </>
  );
};

export default CadastrosGerais;
